import { Mark, mergeAttributes } from '@tiptap/core'

export interface EmailTextStyleAttributes {
  color?: string | null
  lineHeight?: string | null
}

export const EmailTextStyle = Mark.create({
  name: 'emailTextStyle',

  addAttributes () {
    return {
      color: {
        default: null,
        parseHTML: element => element.style.color || null,
      },
      lineHeight: {
        default: null,
        parseHTML: element => element.style.lineHeight || null,
      },
    }
  },

  parseHTML () {
    return [{
      tag: 'span[style]',
      getAttrs: element => {
        const node = element as HTMLElement
        return node.style.color || node.style.lineHeight ? {} : false
      },
    }]
  },

  renderHTML ({ HTMLAttributes }) {
    const styles = [
      HTMLAttributes.color ? `color:${HTMLAttributes.color}` : null,
      HTMLAttributes.lineHeight ? `line-height:${HTMLAttributes.lineHeight}` : null,
    ].filter(Boolean)

    const { color, lineHeight, ...attributes } = HTMLAttributes

    return ['span', mergeAttributes(attributes, { style: styles.join(';') }), 0]
  },
})
